import routeDataSelectorFactory from "./routeDataSelectorFactory.jsx"

export default routeDataSelectorFactory((state) => {
    if (!state) {
      // TODO state undefined after webpack 5 migrating
      return location.hash.substring(1)
    }
    return state.location != null ? state.location.get("pathname") : null
  }
)
